export default __webpack_public_path__ + "static/media/JavaScript.2e10b2a2.png";